"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WiredIdentifier_RuntimeProgressType = exports.WiredIdentifier_KahbaRuntimeUid = exports.WiredIdentifier_TimestampMs = void 0;
// todo: move to central list of
exports.WiredIdentifier_TimestampMs = 'epochMs';
exports.WiredIdentifier_KahbaRuntimeUid = 'kahbaRuntimeUid';
exports.WiredIdentifier_RuntimeProgressType = 'runtimeProgressType';
// todo: reserved prefix for wired/builtin DeclaredIdentifiers
// export const WiredIdentifier_ReservedPrefix = ?;  authors may want to use wranggle.. so 'fanggle' ?
//# sourceMappingURL=wired-identifiers.js.map